import { render } from "./VideosPage.vue?vue&type=template&id=c5641682&ts=true"
import script from "./VideosPage.vue?vue&type=script&lang=ts"
export * from "./VideosPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__